import Head from 'next/head';

import Profile from '../../components/ProfileComp';
import { pageTitle } from '../../components/shared/basic/customHead';

const ProfilePage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('My Profile')}</title>
      </Head>
      <Profile />
    </div>
  );
};

export default ProfilePage;
